import { USER_STATUS } from "../../../../common/model/enum";

export const mapPersonToTableUser = (person) => ({
  id: person.id,
  firstName: person.firstName || "",
  lastName: person.lastName || "",
  name: `${person.firstName || ""} ${person.lastName || ""}`.trim(),
  email: person.email || "",
  status: person.status,
});

export const mapStatusToBadge = (status) => {
  if (status === USER_STATUS.ACTIVATED) {
    return {
      type: "active",
      label: "Actif",
      iconName: "iconCheck",
    };
  }

  if (status === USER_STATUS.ACTIVATION_IN_PROGRESS) {
    return {
      type: "inactive",
      label: "Inactif",
      iconName: "iconPlugs",
    };
  }

   if (status === USER_STATUS.MISSING_INFORMATIONS) {
    return {
      type: "pending",
      label: "Missing informations",
      iconName: "iconWarning",
    };
  }
};
